import {Config} from "angular-ecmascript/module-helpers";
import LoadingInterceptor from "../core/interceptors/loading.interceptor";
import TimeoutConfigInterceptor from "./interceptors/timeoutConfig.interceptor";
import AuthenticationInterceptor from "./interceptors/authentication.interceptor";
import Settings from "./model/settings.model";

export default class HttpConfig extends Config {
    static $inject = ['$httpProvider', 'RestangularProvider'];

    configure() {
        // Interceptors
        this.$httpProvider.interceptors.push(LoadingInterceptor.name);
        this.$httpProvider.interceptors.push(TimeoutConfigInterceptor.name);
        this.$httpProvider.interceptors.push(AuthenticationInterceptor.name);

        // Restangular
        let settings = Settings.load();
        this.RestangularProvider.setBaseUrl(settings.httpUrl());
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/http.config.js